import { onMounted, watch } from 'vue';
import vm from '@journeys/Journeys.viewmodel';

const { editor } = vm;

export const useResetOnNodeOrMenuChange = (props: { nodeId?: number }, callback: () => void) => {
    onMounted(() => {
        watch(() => editor.state.showNodeMenu, callback);

        props.nodeId &&
            watch(
                () => props.nodeId,
                callback
            );
    });
};
